import { Markdown } from "../components/Markdown";
import type { Zine } from "../content";
import {
  zineArchivedLabel,
  zines,
  zinesArchiveHeading,
  zinesCurrentHeading,
  zinesTitle,
} from "../content";
import "../styles/page.css";
import "../styles/zines.css";

function ZineCard({ zine }: { zine: Zine }) {
  return (
    <li className={`zine${zine.archived ? " zine--archived" : ""}`}>
      {/* Whole card is the link, so the cover is a click target too. */}
      <a
        className="zine__link"
        href={zine.pdf}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={`${zine.title}${zine.archived ? ` (${zineArchivedLabel})` : ""} — opens a PDF in a new tab`}
      >
        <img className="zine__cover" src={zine.cover} alt="" aria-hidden="true" />
        {zine.archived && (
          <span className="zine__badge" aria-hidden="true">
            {zineArchivedLabel}
          </span>
        )}
        <h3 className="zine__title">{zine.title}</h3>
        {zine.description && (
          <p className="zine__description">
            <Markdown>{zine.description}</Markdown>
          </p>
        )}
      </a>
    </li>
  );
}

export const Zines = () => {
  // Partitioned by the flag rather than by array order, so ordering the content
  // file stays a free choice.
  const current = zines.filter((zine) => !zine.archived);
  const archived = zines.filter((zine) => zine.archived);

  return (
    <main id="main-content" tabIndex={-1} className="page">
      <header className="page__masthead">
        <div className="page__masthead-inner">
          <h1 className="page__title">{zinesTitle}</h1>
        </div>
      </header>

      <section className="page__section">
        <h2 className="visually-hidden">{zinesCurrentHeading}</h2>
        <ul className="zines">
          {current.map((zine) => (
            <ZineCard key={zine.id} zine={zine} />
          ))}
        </ul>

        {archived.length > 0 && (
          <section className="zines__archive">
            <h2 className="zines__archive-heading">{zinesArchiveHeading}</h2>
            <ul className="zines">
              {archived.map((zine) => (
                <ZineCard key={zine.id} zine={zine} />
              ))}
            </ul>
          </section>
        )}
      </section>
    </main>
  );
};
